import { render, staticRenderFns } from "./BandeiraManage.vue?vue&type=template&id=bc18f158&scoped=true"
import script from "./BandeiraManage.vue?vue&type=script&lang=js"
export * from "./BandeiraManage.vue?vue&type=script&lang=js"
import style0 from "./BandeiraManage.vue?vue&type=style&index=0&id=bc18f158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc18f158",
  null
  
)

export default component.exports